// src/myclipsv3/feed/pendingV3Anchor.ts
//
// Legacy profil (activePage "profile") → klip tıklamasında V3 reels feed'ini
// (FeedContainerV3) AÇMAK için "bekleyen anchor" taşıyıcısı.
//
// NEDEN gerekli: activePage "profile" ile "clips" MUTUALLY EXCLUSIVE render
// edilir → legacy profildeyken FeedContainerV3 MOUNT DEĞİLDİR. Dolayısıyla
// profilden dispatch edilen `mlv3:open-clip`/`mlv3:anchor-clip` window event'ini
// dinleyen kimse yoktur (boşa gider). Çözüm: profil, açılacak klip niyetini
// (clipId + scopedUid) bu modül-seviyesi store'a yazar, sonra
// setActivePage("clips") ile feed'i mount eder; FeedContainerV3 mount olunca
// burayı tüketip klibi profil-kapsamlı (scoped) + tam-ekran reels olarak açar.
//
// Modül-seviyesi singleton kullanılır (sessionStorage DEĞİL): SPA içi aynı JS
// bağlamında senkron geçiş olduğundan serialize gerekmez; obje referansı
// doğrudan taşınır. scopedClips DEĞİL, scopedUid taşınır — legacy profil klip
// objeleri V3 player şekline (mapPlayableClips: transformR2Url'lü `src`) sahip
// olmadığından feed klipleri clipsRepo üzerinden TAZE çeker (doğru şekil).

export interface PendingV3Anchor {
  /** Açılacak (anchor) klibin id'si — feed bu klibe snap'lenir. */
  clipId: string;
  /**
   * Profil sahibinin uid'i. Feed bu uid ile o profilin kliplerini clipsRepo'dan
   * (doğru V3 şekliyle) çeker → grid sırası + sonsuz sayfalama. Yalnız ANA grid
   * tıklamasında set edilir.
   */
  scopedUid?: string | null;
  /**
   * ANINDA AÇILIŞ (siyah-ekran fix): profilin o an yüklü kliplerinin V3 player
   * şekline ÇEVRİLMİŞ hali (mapPlainClipsToPlayable). Varsa feed mount'ta
   * scopedSource'u SENKRON set eder → asenkron fetch beklenmez, siyah ekran
   * olmaz. scopedUid ile sonsuz sayfalama yine devam eder.
   */
  scopedClips?: any[] | null;
}

let _pending: PendingV3Anchor | null = null;

/** Bekleyen anchor'ı yaz (clipId yoksa temizler). */
export function setPendingV3Anchor(p: PendingV3Anchor | null): void {
  _pending = p && typeof p.clipId === "string" && p.clipId ? p : null;
}

/** Bekleyen anchor'ı OKU + TEMİZLE (tek-atımlık tüketim). */
export function consumePendingV3Anchor(): PendingV3Anchor | null {
  const p = _pending;
  _pending = null;
  return p;
}

/** Bekleyen anchor'a tüketmeden bak (test/teşhis). */
export function peekPendingV3Anchor(): PendingV3Anchor | null {
  return _pending;
}
